<template>
    <span v-if="type" class="ls-service-type-pill">{{ type }}</span>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';

const MANUAL_PRICE = 'manual_price';

export default {
    name: 'LsServiceTypePill',
    props: {
        service: VueTypes.shape({
            __typename: VueTypes.oneOf(['Schedule', 'Recommendation', 'RequiredService'])
                .isRequired,
            type: VueTypes.string,
            service: VueTypes.shape({
                price_type: VueTypes.oneOfType([VueTypes.string, VueTypes.oneOfType([null])]),
            }).loose,
        }).isRequired.loose,
    },
    computed: {
        isManualPrice() {
            return _.get(this.service, 'service.price_type') === MANUAL_PRICE;
        },
        type() {
            const types = {
                manualquote: 'quote',
                paw: 'paw',
                qualityassurance: 'qa',
                RequiredService: 'required',
                Recommendation: 'recommended',
            };
            const mapped = types[this.service.type || this.service.__typename];

            // Fallback only, so a RequiredService or Recommendation keeps its own word.
            if (mapped) {
                return mapped;
            }

            return this.isManualPrice ? types.manualquote : undefined;
        },
    },
};
</script>

<style lang="scss">
.ls-service-type-pill {
    background-color: $secondary-light;
    color: $secondary-dark;
    text-transform: uppercase;
    font-weight: $semi-bold;
    padding: 1px 3px;
    font-size: 1.2rem;
    border-radius: $border-radius;
}
</style>
